'use strict';

import { Header } from '../../../frontend/js/header.js';

export default class ExpandableContactButton {
    isInitialized = false;

    initializeScrollEvent() {
        if (window.headroom.initialised) {
            window.headroom.classes = window.headroom.classes || {};
            // Destroy the headroom instance to prevent it from interfering with the expandable contact button,
            // wait 200ms, then create a new instance of the header (the init function on Headroom waits 100ms before initializing)
            window.setTimeout(window.headroom.destroy.bind(window.headroom), 200);
        }
        new Header();
    }

    init() {
        if (this.isInitialized) {
            return
        }
        const expandableContactButton = document.querySelector('.expandable-contact-button');
        const closeButton = document.querySelector('.expandable-contact-button__close')

        if (expandableContactButton) {
            window.lazyLoader.update();
            this.initializeScrollEvent()
            this.isInitialized = true;
            this.offsetWidth = expandableContactButton.offsetWidth;
            expandableContactButton.classList.add('expandable-contact-button--loaded');
            const self = this;

            expandableContactButton.addEventListener('click', (e) => {
                if (e.target !== closeButton) {
                    const isCompressed = document.querySelector('.expandable-contact-button__compressed:not(.hidden)');

                    if (isCompressed) {
                        const compressedElement = document.querySelector('.expandable-contact-button__compressed:not(.hidden)');
                        const expandedElement = document.querySelector('.expandable-contact-button__expanded');
                        const expandedElementIsHidden = expandedElement.classList.contains('hidden');
                        compressedElement.classList.add('hidden');
                        if (expandedElementIsHidden) {
                            expandedElement.classList.remove('hidden');
                            expandableContactButton.classList.add('expandable-contact-button--expanded');
                        }
                    }
                }
            });

            closeButton.addEventListener('click', (e) => {
                const expandedElement = document.querySelector('.expandable-contact-button__expanded');
                const compressedElement = document.querySelector('.expandable-contact-button__compressed');
                expandedElement.classList.add('hidden');
                compressedElement.classList.remove('hidden');
                expandableContactButton.classList.remove('expandable-contact-button--expanded');
            });
        }
    }
    
    hide() {
        const expandableContactButton = document.querySelector('.expandable-contact-button');
        const isHidden = expandableContactButton.classList.contains('hidden');
        if (!isHidden) {
            expandableContactButton.classList.add('hidden');
        }
        else {
            expandableContactButton.classList.remove('hidden');
            console.log("show");
        }
    }
}